<template>
	<div class="form-wrapper">
		<b-row>
			<b-col cols="12" v-if="errorMessage">
				<p class="text-right text-danger">{{ $t(errorMessage) }}</p>
			</b-col>
			<b-col cols="3">
				<h4 class="font-weight-bold">{{ $t('incomes.create.products-items') }}: <span
					class="text-danger">*</span></h4>
				<h3>#{{$t('warehouse.item.total')}}: {{ allTotalCount }}</h3>
				<h5>{{$t('pos.sum')}}: {{ priceTotal | currency({
					symbol:
					computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
					})}}</h5>
			</b-col>
			<b-col cols="9">
				<!--Tabs-->
				<b-tabs content-class="mt-3" @input="focusBarcodeInput">
					<b-modal v-model="openViewProductModal" id="modal-lg" hide-footer size="xl"
							 :title="$t('sidebar.warehouse-management.product-view')"
							 no-close-on-backdrop
							 no-close-on-esc
					>
						<!--<span>{{viewItem}}</span>-->

						<b-table class="generalTableClass"
								 striped="striped"
								 bordered="bordered"
								 small="small"
								 fixed="fixed"
								 :items="viewItem"
								 :fields="computedFieldsForTransfer"
								 responsive="sm"
						>
							<template slot="index" slot-scope="data">
								{{ data.index + 1 }}
							</template>
							<template slot="incomeUzs" slot-scope="data">
								<b-form-group
									breakpoint="lg"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  @focus="$event.target.select()"
													  type="number"
													  v-model.number="data.item.incomingPriceUsd"
													  class="ml-1"
													  :placeholder="$t('incomes.create.incoming-price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">{{ computedDepCurrencyName }}</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</template>
						</b-table>
					</b-modal>

					<b-modal v-model="openModalIfProductHaveMoreThanOnePrice" id="modal-lg-price" hide-footer size="md"
							 :title=" $t('sidebar.pricing.title')">
						<h1>{{ $t('price_different')}}</h1>
						<b-button
							variant="primary"
							size="sm"
							class="float-right ml-2"
							@click="goToNewRoute"
						>
							{{ $t('sidebar.pricing.title')}}
						</b-button>
					</b-modal>

					<b-tab :title="$t('certificate.search')" active>
						<b-form-group
							breakpoint="lg"
							label-size="sm"
							label-cols="2"
							:label="$t('incomes.create.product')"
							label-for="refName"
							class="required mb-1"
						>
							<multiselect v-model="dropDowns.product.value"
										 :options="itemsNotKirim"
										 :searchable="true"
										 :show-labels="false"
										 :internal-search="false"
										 :loading="dropDowns.product.loading"
										 :close-on-select="true"
										 label="name"
										 :disabled="!bothDepsSelected"
										 track-by="id"
										 @search-change="loadItems($event)"
										 :placeholder="$t('incomes.create.product')">

								<template slot="singleLabel" slot-scope="props">
									<span v-if="props.option.wrapped" style="color: blue;">
										<strong><b>Уп.</b>  - </strong>{{ props.option.barcode }} / {{ props.option.artikul }} / {{ props.option.colorName }} / {{ props.option.size
									}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
									</span>
									<span v-else>
										{{ props.option.artikul }} / {{ props.option.colorName }} / {{ props.option.size
									}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
									</span>
								</template>

								<template slot="option" slot-scope="option">
									<span v-if="option.option.wrapped" style="color: blue;">
										<strong><b>Уп.</b>  - </strong>{{ option.option.barcode }} / {{ option.option.artikul }} / {{ option.option.colorName }} / {{ option.option.size
										}} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }}
									</span>
									<span v-else>
										{{ option.option.artikul }} / {{ option.option.colorName }} / {{ option.option.size
										}} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }}
									</span>
								</template>
							</multiselect>
						</b-form-group>
						<b-row>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.price') + showUnit"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  ref="sellPriceRef"
													  id="priceUzs"
													  type="number"
													  @focus="$event.target.select()"
													  v-model.number="(depSaleType && depSaleType === 'WHOLE') ? newItem.priceWholesale : newItem.priceUzs"
													  @keyup.enter="focusNextInput('sellPrice')"
													  :disabled="!isKirim"
													  class="ml-1"
													  :placeholder="$t('incomes.create.price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">{{ computedDepCurrencyName }}</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>

						<b-row>
							<b-col class="col-6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.count')"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input
											type="number"
											:required="true"
											ref="newItemCountRef"
											size="sm"
											id="count"
											@click="$event.target.select()"
											@focus="$event.target.select()"
											class="ml-1"
											@keyup.enter="addItem"
											v-model.number="newItem.count"
											:placeholder="$t('incomes.create.count')"></b-form-input>
										<b-input-group-addon v-if="unitName">
											<b-button disabled size="sm">{{ unitName }}</b-button>
										</b-input-group-addon>
									</b-input-group>

								</b-form-group>
							</b-col>
							<b-col v-if="newItem.itemId" cols="3">
								<span class="badge">{{ $t('incomes.balance') }}:</span> {{ balance }} <span>{{ unitName
								}}</span>
							</b-col>
							<b-col cols="1">
								<b-button v-if="isWrappedComputed && newItem.itemId" block size="sm" type="button"
										  variant="outline-primary"
										  @click="viewProduct(newItem)">
									<i style="color: black" class="fa fa-eye"></i></b-button>

								<b-button v-else-if="isWrappedComputed && lastAddedItem" block size="sm" type="button"
										  variant="outline-primary"
										  @click="viewProduct(lastAddedItem)">
									<i style="color: black" class="fa fa-eye"></i></b-button>
							</b-col>

						</b-row>
						<div class="form-group">
							<b-button type="button"
									  size="sm"
									  :disabled="disableButton"
									  variant="outline-primary"
									  @click="addItem"
									  class="mr-4"
							>
								{{ $t('incomes.create.add-item') }}
							</b-button>
							<span v-if="successBarcode && lastAddedItem"><span class="text-success">{{$t('last-product')}}: </span><strong> &nbsp;{{ lastAddedItem.artikul }} / {{ lastAddedItem.color }} / {{ lastAddedItem.size }} / {{ lastAddedItem.barcode }}</strong><br></span>
							<span v-if="itemFieldsNotFilled"
								  class="ml-3 text-danger">{{ $t('incomes.create.notFilledItem') }}</span>
						</div>
					</b-tab>
					<b-tab :title="$t('goods.barcode')">
						<b-row>
							<b-col class="col-12">
								<b-input-group
									breakpoint="lg"
									label-size="sm"
									label-cols="2"
									:label="$t('incomes.create.barcode')"
									label-for="barcode"
									label-class="ml-1"
									class="required"
									size="sm"
								>
									<b-input-group-text slot="prepend">
								<span class="input-group-addon">
									<i class="fa fa-barcode"></i>
								</span>
									</b-input-group-text>
									<b-form-input
										:required="true"
										size="sm"
										autofocus
										id="barcodeInput"
										ref="barcodeInput"
										autocomplete="off"
										@input="itemBarcodeEntered"
										onClick="setSelectionRange(0, value.length)"
										v-model="barcodeInputValue"
										:placeholder="$t('incomes.create.barcode')">
									</b-form-input>
									<b-input-group-text slot="append" id="for-barcode">
										<b-input-group-addon style="cursor: pointer;"
															 class="input-group-addon barcode-refresh"
															 @click="clearBarcode"
										>
											<i class="fa fa-times"></i>
										</b-input-group-addon>
									</b-input-group-text>
								</b-input-group>
							</b-col>
							<template v-if="barcodeError">
								<b-col class="col-12 mt-2">
									<span class="text-danger">{{ $t('warehouse.document.itemNotFound') }} </span> <span><b> {{
									lastEnteredBarcode }}</b></span>
								</b-col>

							</template>
							<template v-else-if="successBarcode && lastAddedItem">
								<b-col class="col-9 mt-2">
									<span class="text-success">{{$t('last-product')}}: </span> <b> &nbsp;{{
									lastAddedItem.artikul }} / {{ lastAddedItem.color }} / {{ lastAddedItem.size }} / {{
									lastAddedItem.barcode }}</b>
								</b-col>
								<b-col cols="1">

									<b-button v-if="isWrappedComputed" block size="sm" type="button"
											  variant="outline-primary"
											  @click="viewProduct(lastAddedItem)">
										<i style="color: black" class="fa fa-eye"></i></b-button>
								</b-col>
							</template>
						</b-row>
					</b-tab>
				</b-tabs>
				<!--Tabs-->
			</b-col>
		</b-row>
		<div v-if="loading" class="spinner-wrapper">
			<b-spinner></b-spinner>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import WhDocument from "../../../../services/wh-document.service";
import Multiselect from 'vue-multiselect'
import Vue from 'vue'

const initial = {
		id: null,
		documentId: null,
		itemId: null,
		itemName: null,
		count: 1,
		incomingPriceUsd: null,
		currencyId: null,
		priceUsd: null,
		priceUzs: null,
		priceWholesale: null,
		providerId: null,
		providerName: null,
		wrapped: false,
		inventoryNum: null,
		sectorId: null
	};

	export default {
		name: 'CreateItems',

		props: {
			items: {
				type: Array,
				default: []
			},
			allTotalCount: {type: Number},
			incomeTotal: {type: Number},
			priceTotal: {type: Number},
			documentId: {},
			department: {},
			depSaleType: {type: String},
			toDepartmentId: null,
			section: {
				type: String,
				default: 'BOOKING'
			},
			currencyRate: {
				type: Number,
				default: -1
			},
			depCurrencyName: {
				type: String,
				default: ''
			},
			incomeCurrency: {
				type: Object,
				default: {
					name: ''
				}
			}
		},

		components: {
			Multiselect,
			SelectOrCreate: () => import('../../../components/SelectOrCreate')
		},

		created() {
			if (!this.isBooking) {
				this.bothDepsSelected = true;
			}
			this.$barcodeScanner.init(this.barcodeScanned);
			this.loadItems(' ');
			if (this.sections.includes(this.section)) {
				this.pushable = false;
			}
			if (this.department) {
				this.loadSector(this.department)
			}
		},
		destroyed() {
			this.$barcodeScanner.destroy();
		},

		data() {
			return {
				computedFieldsForTransfer: [
					{
						key: 'artikul',
						label: this.$t('goods.artikul'),
						'class': 'incomeItemArtikul',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'color',
						label: this.$t('goods.color'),
						'class': 'incomeItemArtikul',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'size',
						label: this.$t('goods.size'),
						'class': 'incomeItemSize',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'name',
						label: this.$t('incomes.create.product'),
						'class': 'not-first',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'amount',
						label: this.$t('incomes.create.count'),
						'class': 'td-30',
						sortable: true,
						visible: true,
						changebale: true
					},

					{
						key: 'barcode',
						label: this.$t('goods.barcode'),
					},
					{
						key: 'priceUzs',
						label: `${this.$t('incomes.create.price')} (Сумма)`,
						'class': 'td-30',
						sortable: true,
						visible: true,
						changebale: true
					},


				],
				openModalIfProductHaveMoreThanOnePrice: false,
				disableButton: false,
				bothDepsSelected: true,
				publicPath: process.env.BASE_URL,
				loading: false,
				itemFieldsNotFilled: false,
				noDepartment: false,
				fileSelected: null,
				fileNotSelectMessage: false,
				barcodeFn: false,
				isBarcodeScanned: false,
				dropDowns: {
					product: {
						items: [],
						value: null,
						loading: false,
						search: {
							page: 1,
							limit: 10,
							attributes: [{
								field: 'name',
								value: '',
								option: 'CONTAINS'
							}]
						}
					},
				},
				dropdowns: {
					sector: {
						items: [],
						value: null,
					}
				},
				lastEnteredBarcode: null,
				lastAddedItem: null,
				openViewProductModal: false,
				successBarcode: null,
				newItem: {
					id: null,
					documentId: null,
					itemId: null,
					itemName: null,
					count: 1,
					incomingPriceUsd: null,
					currencyId: null,
					priceUsd: null,
					incomingPriceUzs: null,
					priceWholesale: null,
					price: null,
					priceUzs: null,
					providerId: null,
					providerName: null,
					inventoryNum: null,
					wrapped: false,
					sectorId: null,
					barcode: null,
					excelFile: ''
				},
				barcodeInputValue: '',
				timeout: null,
				unitName: '',
				viewItem: [],
				convert: false,
				isWrapped: false,
				// balance: 0,
				pushable: true,
				errorMessage: null,
				sections: ['CHIQIM', 'KOCHIRISH', 'SPISAT', 'BOOKING'],
				isExcelDisabled: false
			}
		},

		methods: {
			async wrappedItemSelected(item) {
				let obj = {}
				obj.itemId = item.itemId;
				if (this.customDepartments.section == 'KOCHIRISH') {
					obj.departmentId = this.customDepartments.fromDepartmentId;
				}
				if (this.customDepartments.section == 'KIRIM') {
					obj.departmentId = this.customDepartments.toDepartmentId;
				}
				if (this.viewItem.length > 0) {
					if (this.viewItem[0].parentId !== item.itemId) {
						await WhDocument.getViewPRoductItems(obj)
							.then(response => {
								this.viewItem = response.data;
							}).then(payload => {
								this.saveWrappedModal(this.viewItem);
							}).catch(e => {
								this.viewItem = [];
							})
					} else {
						this.saveWrappedModal(this.viewItem);
					}
				} else {
					await WhDocument.getViewPRoductItems(obj)
						.then(response => {
							this.viewItem = response.data;
						}).then(payload => {
							this.saveWrappedModal(this.viewItem);
						}).catch(e => {
							this.viewItem = [];
						})
				}
			},
			closeWrappedModal() {
				this.openViewProductModal = false;
			},
			saveWrappedModal(viewItem) {
				this.newItem.incomingPriceUsd = 0;
				viewItem.forEach(el => {
					if (el.incomingPriceUsd) {
						this.newItem.incomingPriceUsd += el.incomingPriceUsd > 0 ? el.incomingPriceUsd * el.amount : 0;
					} else {
						this.newItem.incomingPriceUsd += 0;
					}
				})
				this.openViewProductModal = false;
			},
			openModalPriceDifference() {
				this.openModalIfProductHaveMoreThanOnePrice = true;
			},

			goToNewRoute() {
				this.openModalIfProductHaveMoreThanOnePrice = false;
				window.open(window.location.origin + "/" + "point-of-sale/prices", '_blank');
			},

			async loadSector(id) {
				await WhDocument.getSectorByDepartmentId(id).then(response => {
					this.dropdowns.sector.items = response;
					this.$store.commit('warehouse/setSector', this.dropdowns.sector.items);
				})
			},
			async viewProduct(item) {
				let obj = {}
				obj.itemId = item.itemId;
				if (this.customDepartments.section == 'KOCHIRISH' || this.customDepartments.section == 'SPISAT') {
					obj.departmentId = this.customDepartments.fromDepartmentId;
				}
				if (this.customDepartments.section == 'KIRIM') {
					obj.departmentId = this.customDepartments.toDepartmentId;
				}
				if (this.isKirim) {
					WhDocument.getViewPRoductItems(obj)
						.then(response => {
							this.viewItem = response.data;
						}).catch(e => {
							this.viewItem = [];
						})
				} else {
					let payload = {
						itemId: item.itemId,
						docId: item.docId
					}
					await this.getWrappedItemsById(payload)
					this.viewItem = this.lastWrappedItems;
					// WhDocument.getWrapped(obj)
					// 	.then(response => {
					// 		this.viewItem = response.data;
					// 	}).catch(e => {
					// 		this.viewItem = [];
					// 	})
				}
				this.openViewProductModal = true;
			},

			...mapActions('goods', [
				'fetchGoodsWithKeyword', 'fetchItemWithBarcode', 'fetchItemWithBarcodeNotIncome', 'getWrappedItemsById'
			]),
			...mapActions('warehouse', [
				'lastPriceByItemId', 'loadBalance', 'getListByProductsNotKirim',
				'setDefaultToIsNotKrim', 'loadNewBalance', 'changePriceNotDifferent',
				'uploadExcelForIncome'
			]),
			clearBarcode() {
				this.barcodeInputValue = '';
				this.focusBarcodeInput(1);
			},
			/**
			 *  Load and search items
			 * @param $event
			 * @param by
			 */
			async loadItems($event, by = 'name') {
				this.dropDowns.product.loading = true;
				/*if ($event !== null) {
					this.dropDowns.product.search.attributes[0].value = $event;
				}*/
				if (this.isKirim) {
					await this.fetchGoodsWithKeyword($event);

				} else if (this.department) {
					if ($event.toString().trim() == '') {
						$event = null;
					}
					let obj = {};
					obj.keyword = $event;
					obj.depId = this.customDepartments.fromDepartmentId;
					// let str = "keyword=" + $event + "&depId=" + this.customDepartments.fromDepartmentId;
					this.getListByProductsNotKirim(obj);

				}


				/*GoodsService.fetchGoodsWithKeywoard($event).then(response => {
					this.dropDowns.product.items = (response.data);
				})*/
				if (this.withKeywordError) {
					this.$vs.notify({
						text: this.withKeywordError,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}
				this.dropDowns.product.loading = false;
			},

			/**
			 *  Add Warehouse item
			 */
			async addItem(eventOrFromWhere) {
				if (!this.department) {
					this.$vs.notify({
						text: this.$t('department.choose-department'),
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					return 0;
				}
				if (this.dropDowns.product.value || this.itemWithBarcode) {
					this.loading = true;
					this.newItem.documentId = this.documentId;
					this.newItem.inventoryNum = this.balance;
					this.newItem.count = (this.newItem.count && this.newItem.count > 0) ? this.newItem.count : 1;

					if (this.newItem.count > this.balance) {
						this.newItem.count = this.balance;
					}
					if (this.newItem.count <= 0) {
						this.$vs.notify({
							time: 1200,
							title: "Количество",
							text: 'Проверьте количество товара!',
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						if (this.$refs.newItemCountRef) {
							this.$refs.newItemCountRef.focus();
						}
						this.loading = false;
						return 0;
					}
					this.newItem.bookingId = this.currentDoc.id
					this.newItem.toDepartmentId = this.toDepartmentId
					this.newItem.fromDepartmentId = this.department
					let findIndex = this.items.findIndex(el => {
						return el.itemId == this.newItem.itemId;
					});
					if (findIndex >= 0) {
						if ((this.items[findIndex].count + this.newItem.count <= this.items[findIndex].realBalance)) {
							if (this.isBooking) {
								if (eventOrFromWhere !== 'fromBarcodeFn') {
									this.newItem.barcode = this.dropDowns.product.value.barcode;
									this.newItem.artikul = this.dropDowns.product.value.artikul;
									this.newItem.color = this.dropDowns.product.value.colorName;
									this.newItem.size = this.dropDowns.product.value.size;
									this.newItem.unitName = this.dropDowns.product.value.unitName;
									this.newItem.docId = this.dropDowns.product.value.docId
								}
								this.newItem.currencyId = this.incomeCurrency.id ? this.incomeCurrency.id : null;
								let temp = Object.assign({}, this.newItem);
								this.lastAddedItem = Object.assign({}, this.newItem);
								this.successBarcode = true;
								this.$store.commit('goods/setBarcodeError', false);
								this.$emit('success', temp);
								if (this.newItem.wrapped) {
									this.isWrapped = true;
								} else {
									this.isWrapped = false;
								}
								Object.assign(this.newItem, initial);
								this.newItem.priceUsd = null;
								this.newItem.priceUzs = null;
								this.newItem.count = 1;
								this.newItem.incomingPriceUsd = null
								this.dropDowns.product.value = null;
								this.incomingPriceUzs = null;
								this.loading = false;
							}
						} else {
							this.$emit('changeRowVariant', findIndex);
							this.loading = false;
							this.$vs.notify({
								title: "Количество",
								text: 'Проверьте количество товаров!',
								color: 'warning',
								icon: 'close',
								position: 'top-right'
							});
						}
					} else {
						if (eventOrFromWhere !== 'fromBarcodeFn') {
							this.newItem.barcode = this.dropDowns.product.value.barcode;
							this.newItem.artikul = this.dropDowns.product.value.artikul;
							this.newItem.color = this.dropDowns.product.value.colorName;
							this.newItem.size = this.dropDowns.product.value.size;
							this.newItem.unitName = this.dropDowns.product.value.unitName;
							this.newItem.docId = this.dropDowns.product.value.docId
							if (this.dropDowns.product.value) {
								if (this.dropDowns.product.value.wrapped) {
									this.newItem.wrappedItems = this.viewItem;
								}
							}
						}
						this.newItem.currencyId = this.incomeCurrency.id ? this.incomeCurrency.id : null;
						let temp = Object.assign({}, this.newItem);
						this.lastAddedItem = Object.assign({}, this.newItem);
						this.successBarcode = true;
						this.$store.commit('goods/setBarcodeError', false);
						this.$emit('success', temp);
						this.loading = false;
						setTimeout(() => {
							if (this.newItem.wrapped) {
								this.isWrapped = true;
							} else {
								this.isWrapped = false;
							}
							Object.assign(this.newItem, initial);
							this.dropDowns.product.value = null;
							// this.balance = 0;
							this.$store.commit('warehouse/resetCurrentItemBalance');
							this.unitName = '';
							if (this.newItem.incomingPriceUsd) {
								this.newItem.incomingPriceUsd = null
							}
							if (this.newItem.incomingPriceUzs) {
								this.newItem.incomingPriceUzs = null
							}
							this.newItem.priceUsd = null;
							this.newItem.priceUzs = null
						}, 100);
					}
				} else {
					this.$vs.notify({
						time: 1200,
						title: this.$t('please-select-product'),
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					this.itemFieldsNotFilled = true;
				}
			},
			async loadLastPrice(itemId, fromWhere) {
				let pricingItemPayload = {
					itemId: itemId,
					department: this.department,
					type: this.depSaleType
				};
				//await this.lastPriceByItemId(pricingItemPayload);
				if((this.isBooking && this.depSaleType) || this.isSpisat){
					await this.loadNewBalance(pricingItemPayload);
				}
				if (this.newItem) {
					this.newItem.priceUzs = this.pricingItem.priceUzs ? this.pricingItem.priceUzs : null;
					this.newItem.priceWholesale = this.pricingItem.priceWholesale ? this.pricingItem.priceWholesale : null;
					this.newItem.incomingPriceUzs = this.pricingItem.incomePriceUzs ? this.pricingItem.incomePriceUzs : null;
					this.newItem.price = this.pricingItem.price;
				}
				if (this.barcodeFn || this.isBarcodeScanned) {
					// this.successBarcode = true;
					if (!this.isKirim) {
						let itemBalancePayload = {
							itemId: this.newItem.itemId,
							department: this.department,
							type: this.depSaleType
						}
						await this.loadNewBalance(itemBalancePayload);
						this.pushable = this.balance > 0
					}
					if (fromWhere == 'fromBarcodeFn') {
						await this.addItem(fromWhere);
					} else {
						await this.addItem();
					}
					this.barcodeFn = false;
					this.isBarcodeScanned = false;
				}
				if (this.currentPricingItemError || this.currentItemBalanceError) {
					this.newItem.incomingPriceUzs = null;
					this.newItem.priceUzs = null;
					//this.$refs.incomingPriceRef.focus();
					this.barcodeFn = false;
					this.isBarcodeScanned = false;
				}
			},
			focusNextInput(fromInput) {
				if (fromInput == 'incomePrice') {
					if (!this.newItem.incomingPriceUzs || this.newItem.incomingPriceUzs == '') {
						this.$refs.incomingPriceRef.focus();
					} else {
						this.$refs.sellPriceRef.focus();
					}
				} else {
					if (!this.newItem.priceUzs || this.newItem.priceUzs == '') {
						this.$refs.sellPriceRef.focus();
					} else {
						this.$refs.newItemCountRef.focus();
					}
				}
				/*if (!this.newItem.incomingPriceUzs || this.newItem.incomingPriceUzs == '') {
					this.$refs.incomingPriceRef.focus();
				} else if (!this.newItem.priceUzs || this.newItem.priceUzs == '') {
					this.$refs.sellPriceRef.focus();
				} else {
					this.$refs.newItemCountRef.focus();
				}*/
			},
			itemBarcodeEntered(val) {
				if (!this.isBarcodeScanned) {
					clearTimeout(this.timeout);
					this.barcodeFn = true;
					let vm = this;
					this.timeout = setTimeout(async function () {
						if (!vm.department) {
							vm.noDepartment = true;
							vm.clearBarcodeInput();
							vm.focusBarcodeInput(1);
							vm.barcodeFn = false;
							return 0;
						}
						if (val.length > 3 && !vm.isBarcodeScanned) {
							vm.lastEnteredBarcode = val;
							await vm.fetchItemWithBarcode(val);
							vm.clearBarcodeInput();
							if (vm.itemWithBarcode) {
								vm.unitName = vm.itemWithBarcode.unitName;
								vm.newItem.itemId = vm.itemWithBarcode.id;
								vm.newItem.itemName = vm.itemWithBarcode.name;
								vm.newItem.count = 1;
								vm.loadLastPrice(vm.itemWithBarcode.id);
								// vm.$refs.barcodeItemCount.focus();
							} else if (vm.barcodeError) {
								vm.clearBarcodeInput();
								vm.focusBarcodeInput(1);
								vm.barcodeFn = false;
								vm.successBarcode = false;
								vm.$vs.notify({
									time: 1200,
									title: this.$t('warehouse.document.itemNotFound'),
									color: 'danger',
									icon: 'close',
									position: 'top-right'
								});
							}
						}
					}, 100);
				}
			}
			,
			async barcodeScanned(barcode) {
				this.isBarcodeScanned = true;
				this.barcodeFn = false;
				this.lastEnteredBarcode = barcode;
				if (!this.department) {
					this.noDepartment = true;
					this.clearBarcodeInput();
					this.focusBarcodeInput(1);
					this.isBarcodeScanned = false;
					this.successBarcode = false;
					return 0;
				}
				if (this.isBarcodeTab) {
					if (this.isKirim) {
						await this.fetchItemWithBarcode(barcode);
					} else {
						let dep = this.department;
						let otherDepId = this.toDepartmentId;
						let payload = {
							barcode: barcode,
							depId: this.department
						};
						await this.fetchItemWithBarcodeNotIncome(payload)
					}
					this.clearBarcodeInput();
					if (this.itemWithBarcode) {
						this.isWrapped = this.itemWithBarcode.wrapped
						this.unitName = this.itemWithBarcode.unitName;
						this.newItem.itemId = this.itemWithBarcode.id;
						this.newItem.itemName = this.itemWithBarcode.name;
						this.newItem.count = 1;
						this.newItem.wrapped = this.itemWithBarcode.wrapped;
						this.newItem.barcode = this.itemWithBarcode.barcode;
						this.newItem.artikul = this.itemWithBarcode.artikul;
						this.newItem.color = this.itemWithBarcode.colorName;
						this.newItem.size = this.itemWithBarcode.size;
						this.newItem.docId = this.itemWithBarcode.docId
						if (this.newItem.wrapped) {
							await this.wrappedItemSelected(this.newItem);
							this.newItem.wrappedItems = this.viewItem;
						}
						await this.loadLastPrice(this.itemWithBarcode.id, 'fromBarcodeFn');
						/*if (this.isBooking) {
							await this.loadBalance(this.itemWithBarcode.id)
						}*/
						this.$refs.barcodeInput.focus();
						// vm.$refs.barcodeItemCount.focus();
					} else if (this.barcodeError) {
						this.isBarcodeScanned = false;
						this.successBarcode = false;
						this.clearBarcodeInput();
						this.focusBarcodeInput(1);
						this.$vs.notify({
							time: 1200,
							title: this.$t('warehouse.document.itemNotFound'),
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}
				}
			},
			barcodeItemCountEntered() {
				if (this.newItem.count > 0) {
					this.addItem();
					this.$store.commit('goods/setItemWithBarcode', null);
					this.focusBarcodeInput(1);
				}
			}
			,
			focusBarcodeInput($event) {
				if ($event == 1) {
					// this.$barcodeScanner.init(this.itemBarcodeEntered);
					this.$refs.barcodeInput.focus();
					this.$store.commit('goods/setBarcodeTab', true);
					this.$refs.barcodeInput.$el.value = '';
					this.$refs.barcodeInput.focus();
				} else {
					// this.$barcodeScanner.destroy();
					this.$store.commit('goods/setBarcodeTab', false);
					this.newItem.incomingPriceUzs = null;
					this.newItem.priceUzs = null;
				}
			}
			,
			clearBarcodeInput() {
				this.barcodeInputValue = '';
				this.$refs.barcodeInput.$el.value = '';
			}
			,
		},

		watch: {
			'department': {
				handler(newVal) {
					this.dropDowns.product.value = null;
					if (newVal) {
						if (this.isBooking) {
							if (this.toDepartmentId) {
								this.bothDepsSelected = true;
							}
						}

						this.dropDowns.product.value = null;
						this.disableButton = true;
						this.newItem.priceUzs = null;
						this.loadItems(' ');
						this.loadSector(newVal)
					}
				}
			},
			'toDepartmentId': {
				handler(newVal) {
					if (newVal) {
						if (this.isBooking) {
							if (this.department) {
								this.bothDepsSelected = true;
							}
						}
						this.dropDowns.product.value = null;
						this.disableButton = true;
						this.newItem.priceUzs = null;
						this.loadItems(' ');
					}
				}

			},
			'priceIsNotDifferent': {
				handler(newVal) {
					if (newVal === false && this.isBooking) {
						this.openModalPriceDifference();
						this.dropDowns.product.value = null;
						this.disableButton = true;
						this.newItem.priceUzs = null;
						this.changePriceNotDifferent();
						this.barcodeFn = false;
						this.isBarcodeScanned = false;
					}

				}
			},
			'dropDowns.product.value': {
				async handler(newValue, oldValue) {
					if (oldValue == null) {
						this.disableButton = false;
					}
					if (newValue) {
						this.newItem.wrapped = newValue.wrapped;
						this.newItem.docId = newValue.docId;
						this.isWrapped = newValue.wrapped;
					}

					if (!this.department) {
						this.noDepartment = true;
						return 0;
					}
					this.noDepartment = false;
					if (!newValue) {
						this.unitName = '';
						this.newItem.incomingPriceUzs = null;
						this.newItem.priceUzs = null;
						// this.balance = 0;
						this.$store.commit('warehouse/resetCurrentItemBalance');
						return;
					}
					this.itemFieldsNotFilled = false;
					if ((this.sections.includes(this.section)) && this.department) {
						this.errorMessage = null;
						let itemBalancePayload = {
							itemId: newValue.id,
							department: this.department
						}

						this.newItem.count = 1;
						if (this.section == 'KOCHIRISH' || this.section == 'SPISAT' || this.section == 'BOOKING') {
							this.loadLastPrice(newValue.id);
						}
						if (this.$refs.newItemCountRef) {
							this.$refs.newItemCountRef.focus();

						}
					} else if (this.sections.includes(this.section) && !this.department) {
						this.dropDowns.product.value = null;
						this.errorMessage = 'incomes.select-department'
					} else if (!this.sections.includes(this.section) && this.department) {
						if (newValue.wrapped) {
							if (newValue && oldValue) {
								if (newValue.id !== oldValue.id) {
									Vue.set(newValue, "itemId", newValue.id)
									await this.wrappedItemSelected(newValue);
								}
							} else {
								Vue.set(newValue, "itemId", newValue.id)
								await this.wrappedItemSelected(newValue);
							}
						}
						this.newItem.count = 1;
						this.loadLastPrice(newValue.id);
					}

					this.unitName = newValue.unitName;
					this.newItem.itemId = newValue.id;
					this.newItem.itemName = newValue.name;
				}
			},
			isBarcodeTab: {
				handler(newVal) {
					if (newVal) {
						// this.$barcodeScanner.init(this.barcodeScanned);
						this.$refs.barcodeInput.$el.value = '';
						this.$refs.barcodeInput.focus();
					} else {
						// this.$barcodeScanner.destroy();
					}
				}
			},
			noDepartment: {
				handler(newVal) {
					if (newVal) {
						this.$vs.notify({
							text: this.$t('department.choose-department'),
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						this.dropDowns.product.value = null;
						this.noDepartment = false;
					}
				}
			},
			'newItem.priceUsd': {
				handler(newValue) {
					if (this.currencyRate !== -1 && this.convert) {
						this.newItem.priceUzs = newValue * this.currencyRate;
					}
				}
			},
			'newItem.incomingPriceUsd': {
				handler(newValue) {
					if (this.currencyRate !== -1 && this.convert) {
						this.newItem.incomingPriceUzs = newValue * this.currencyRate;
					}
				}
			},

			'newItem.incomingPriceUzs': {
				handler(newValue) {
					if (this.currencyRate !== -1 && this.convert) {
						this.newItem.incomingPriceUsd = newValue / this.currencyRate;
					}
				}
			},


			'newItem.priceUzs': {
				handler(newValue) {
					if (this.currencyRate !== -1 && this.convert) {
						this.newItem.priceUsd = newValue / this.currencyRate;
					}
				}
			},

			'newItem.count': {
				handler(newValue) {
					if (this.sections.includes(this.section) && newValue > this.balance) {
						setTimeout(() => {
							this.newItem.count = this.balance;
						}, 100);
					}
				}
			},
			'newItem.excelFile': {
				handler(newValue) {
					if (newValue === null) {
						this.fileSelected = null
					} else {
						this.fileNotSelectMessage = false
						this.fileSelected = true
					}

				}
			},
		},

		computed: {
			computedDepCurrencyName() {
				return this.depCurrencyName || this.incomeCurrency.name || this.userDepCurrencyName;
			},
			isWrappedComputed() {
				return this.isWrapped;
			},
			isXlsDisabled() {
				return this.isExcelDisabled;
			},
			...mapState('booking', [
				'currentDoc'
			]),
			...mapState(['userDepCurrencyName']),
			...mapState('goods', [
				'goodsForMultiselect', 'withKeywordError',
				'itemWithBarcode', 'barcodeError', 'isBarcodeTab', 'lastWrappedItems'
			]),
			...mapState('warehouse', [
				'pricingItem', 'balance', 'customDepartments',
				'currentItemBalanceError', 'currentPricingItemError', 'itemsNotKirim', 'priceIsNotDifferent',
				'foundItemsFromXls', 'notFoundItemsFromXls'
			]),
			isKirim() {
				return this.section === 'KIRIM';
			},
			isChiqim() {
				return this.section === 'CHIQIM';
			},
			isTransfer() {
				return this.section === 'KOCHIRISH';
			},
			isBooking() {
				return this.section === 'BOOKING';
			},
			isSpisat() {
				return this.section === 'SPISAT';
			},
			showUnit() {
				return (this.unitName) ? ` (${this.unitName})` : ``;
			},
			isEnable() {
				return (this.loading || !this.pushable || this.newItem.count < 1) && this.unitName !== null;
			}
		}
	}
</script>

<style scoped lang="scss">
	.form-wrapper {
		position: relative;
		padding: 15px;
		border-bottom: 1px solid #e1e1e1;
		margin: 15px 0;
		border-top: 1px solid #e1e1e1;
	}

	.spinner-wrapper {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		text-align: center;
		background: rgba(0, 0, 0, 0.09);
		bottom: 0;
		z-index: 2;
		padding-top: 60px;
	}

	.generalTableClass {
		max-height: 500px;
		overflow-y: scroll;
	}
	.generalTableClass thead tr {
		th, td {
			&.width18 {
				width: 18% !important;
			}
		}
	}
</style>
